import { WebsiteConfig } from '@wbk/contentful/api';
import { ImageWithPlaceholder, Typography } from '@wbk/ui';

type Props = {
  config: WebsiteConfig;
};
type SponsorCardProps = {
  sponsor: {
    id: string;
    title: string;
    logo: {
      url: string;
    };
    link?: string;
  };
};
const SponsorCard = ({ sponsor }: SponsorCardProps) => {
  const containerClass =
    'flex h-16 w-36 flex-col items-center justify-center rounded-lg border border-[#eff6ff33] p-4 md:h-24 md:w-40 md:!rounded-3xl hover:opacity-80 transition-opacity duration-300';
  const img = (
    <ImageWithPlaceholder
      src={sponsor.logo.url}
      alt={sponsor.title}
      className='h-8 w-auto object-contain md:h-12 md:w-auto'
    />
  );
  if (sponsor.link) {
    return (
      <a
        href={sponsor.link || '#'}
        target='_blank'
        rel='noopener noreferrer'
        className={containerClass}
      >
        {img}
      </a>
    );
  }

  return <div className={containerClass}>{img}</div>;
};
const Sponsors = ({ config }: Props) => {
  const data = config.footer.sponsorsCollection;

  return (
    <div className='container flex flex-col items-center justify-center py-4'>
      {(data?.items ?? [])?.map((section, index) => (
        <div
          key={index}
          className='flex flex-col items-center justify-center gap-4 py-4 text-center'
        >
          <Typography
            as='h4'
            variant='body-M'
            className='md:text-body-L font-semibold uppercase dark:text-white'
          >
            {section.title}
          </Typography>

          <div className='flex flex-wrap items-center justify-center gap-2 md:gap-4 lg:flex-nowrap rtl:flex-row-reverse'>
            {(section.sponsorsCollection.items ?? []).map((sponsor) => (
              <SponsorCard key={sponsor?.id} sponsor={sponsor} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Sponsors;
